import DefaultPersonalizationConfig from "../PersonalizationComponents/DefaultPersonalizationConfig";

import BamlLogo from "./baml-logo.png";
import EmpowerLogo from "./empower-logo.png";
import EqLogo from "./eq-logo.png";
import FidelityLogo from "./fidelity-logo.png";
import JpmLogo from "./jpm-workplace-logo.png";
import MsEtradeLogo from "./etrade-ms-logo.png";
import SalusLogo from "./salus-logo-secondary.png";
import SchwabLogo from "./schwab-logo.png";
import UbsLogo from "./ubs-logo.png";
import GsLogo from "./gs-logo.png";
import CoinbaseLogo from "./coinbase-logo.png";


export function getPartnerLogo(branding: string = DefaultPersonalizationConfig.branding) {
  switch (branding) {
    case "jpm":
      return JpmLogo;
    case "ms_etrade":
      return MsEtradeLogo;
    case "eq":
      return EqLogo;
    case "empower":
      return EmpowerLogo;
    case "ubs":
      return UbsLogo;
    case "schwab":
      return SchwabLogo;
    case "fidelity":
      return FidelityLogo;
    case "baml":
      return BamlLogo;
    case "gs":
      return GsLogo;
    case "coinbase":
      return CoinbaseLogo;
    case "salus":
      return SalusLogo;
    default:
      return SalusLogo;
  }
}

const PartnerLogo = getPartnerLogo();

export default PartnerLogo;